import * as React from "react";
export const ParceiroAgregadoBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
